import { withProps } from 'recompose';
import Collapsible from 'react-collapsible';
import './styles.scss';

export default withProps({ easing: 'ease-in-out', transitionTime: 280 })(Collapsible);
